import { Directive, Output, HostListener, EventEmitter } from '@angular/core';


@Directive({ selector: '[appCapsLock]' })
export class CapsLockDirective {

  @Output()
  public capsLock = new EventEmitter<boolean>();

  /**
   * Function that listen the keydown event
   * @param event: Keyboard event
   */
  @HostListener('window:keydown', ['$event'])
  public onKeyDown(event: KeyboardEvent): void {
    this.capsLock.emit(event.getModifierState && event.getModifierState('CapsLock'));
  }

  /**
   * Function that listen the keyup event
   * @param event: Keyboard event
   */
  @HostListener('window:keyup', ['$event'])
  public onKeyUp(event: KeyboardEvent): void {
    this.capsLock.emit(event.getModifierState && event.getModifierState('CapsLock'));
  }
}
